import { InstantSearch } from 'react-instantsearch';

import { searchClient } from '@klv/utils/search-client';

import WhatsNewSearchForm from './whats-new-search-form';

import type { IWhatsNewTimeline } from './types';


const WhatsNewTimeline = (props: IWhatsNewTimeline) => (
  <InstantSearch searchClient={searchClient} insights>
    <WhatsNewSearchForm {...props}/>
  </InstantSearch>
);

export default WhatsNewTimeline;
